module.exports = __webpack_public_path__ + "img/highlight_bladerunner.a9d57cca.png";